module.exports = __webpack_public_path__ + "static/UntitledSansWeb-Regular-9ff34e37edb2efed0906407d839c2379.woff";